import { COLORS } from '@repo/design-system/index'
import { QIcon_study_active_gift } from '@repo/icons/index'
import { useQuery } from '@tanstack/react-query'
import Image from 'next/image'
import { n_purchase } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import client from '../../../modules/sanityClient'
import { FETCH_PRICING_EVENT_LIST_DATA } from '../../../sanity/groqQueries'
import PricingBenefitInfo from './Pricing/PricingBenefitInfo'

const fetchPricingEventList = async () => {
  try {
    const responses = await client.fetch(FETCH_PRICING_EVENT_LIST_DATA)
    return responses
  } catch (error) {
    console.error('Failed to fetch data:', error)
    throw error
  }
}

export const usePricingEventList = () => {
  return useQuery({
    queryKey: ['pricing_event_list_data'],
    queryFn: fetchPricingEventList,
  })
}

const PricingEventList = ({ isFirstPurchaseBenefitUser = null }) => {
  const { t, locale } = useTranslation()

  const { data: pricingEventListData } = usePricingEventList()
  const events = pricingEventListData?.event_list || []

  return (
    <>
      {isFirstPurchaseBenefitUser && (
        <PricingBenefitInfo
          title={
            <div className="flex gap-x-2 items-center">
              <span className="flex text-red-500 Body2-14Bd whitespace-pre">
                {t(n_purchase.event.first_purchase_1)}
              </span>
            </div>
          }
          subTitle={t(n_purchase.event.first_purchase_2)}
          icon={<QIcon_study_active_gift width={20} height={20} color={COLORS.RED400} />}
          borderBottom={events?.length === 0}
        />
        // NOTE: 첫 구매 혜택 (24시간 내 구매 시 수업권 추가)
        // <PricingBenefitInfo
        //   title={
        //     <div className="flex gap-x-2 items-center">
        //       <span className="flex text-red-500 Body2-14Bd whitespace-pre">
        //         {t(
        //           n_pricing.event.first_purchase(
        //             <DdayCounter
        //               initialDay={new Date()}
        //               targetDay={
        //                 new Date(
        //                   currentUser ? add24Hours(currentUser?.braze?.private?.signup_date) : add24Hours(new Date())
        //                 )
        //               }
        //               types={[D_DAY_TYPE.HOUR, D_DAY_TYPE.MIN, D_DAY_TYPE.SEC]}
        //               classNameTotalContainer="flex items-center"
        //               classNameDigitContainer="text-red-500 Body2-14Bd flex items-center justify-center"
        //               seperator={
        //                 <div className="text-red-500 Body2-14Bd flex flex-col justify-center items-center">:</div>
        //               }
        //             />
        //           )
        //         )}
        //       </span>
        //     </div>
        //   }
        //   subTitle={t(n_pricing.event.first_purchase_con)}
        //   icon={<QIcon_clock width={20} height={20} color={COLORS.RED400} />}
        //   borderBottom={events?.length === 0}
        // />
      )}

      {events?.map((data, index) => {
        const localizedEvent = data[locale] || data['en']
        return (
          <div className="py-12 flex items-center gap-x-8 border-t last:border-b" key={index}>
            <Image
              width={20}
              height={20}
              src={'https://d38emex6h5e12i.cloudfront.net/2024-image/1727316354773_event_icon.webp'}
              alt="icon"
            />
            <div className="flex gap-4 sm:flex-row flex-col items-start sm:items-center">
              <span className="text-gray-700 Body2-14Md">{localizedEvent?.title}</span>
              <span className="text-gray-500 Caption-12Md">{localizedEvent?.subTitle}</span>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default PricingEventList
